<template>
  <nd-dialog
    v-model="visible"
    :footer="false"
    class="detention-dialog"
  >
    <img src="../image/img_detention_top.png" class="top-image">
    <div
      v-if="sensorsCaseId"
      class="content"
      :data-sensors-exposure-property-msg_name="sensorsMessagesName"
      :data-sensors-exposure-property-caseId="sensorsCaseId"
      data-sensors-exposure-event-name="PopupDisplay"
    >
      <div class="title">{{ title }}</div>
      <template v-if="pageType==='LOAN'">
        <div class="desc">今日资金充足，限时<span class="text-primary bold">通过率翻倍</span></div>
      </template>
      <template v-else>
        <div class="desc">老客专享资金，借一笔立享<span class="text-primary bold"><slot></slot></span>机会</div>
      </template>
      <nd-button @click="continueAction" class="continue">继续提现</nd-button>
      <div @click="giveUpAction" class="give-up">放弃</div>
    </div>
  </nd-dialog>
</template>

<script>
export default {
  name: 'DetentionDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // 用于区分是哪个页面的弹窗, 'LOAN' 为借款页面, 'PREVIEW' 为预览提现页面
    pageType: {
      type: String,
      default: 'LOAN'
    },
    sensorsCaseId: {
      type: String,
      default: 'LOAN50'
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    title () {
      return this.pageType === 'LOAN' ? '拿钱仅差一步，您确定要放弃吗?' : '实时审批，1分钟到账'
    },
    sensorsMessagesName () {
      return 'retain'
    }
  },
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    continueAction () {
      this.visible = false
    },
    giveUpAction () {
      this.visible = false
      this.$emit('onGiveUp')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.detention-dialog {
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 30px;
    .title {
      font-size: 36px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 50px;
      margin-top: 45px;
    }
    .desc {
      font-size: 30px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 42px;
      margin-top: 8px;
    }
    .continue {
      width: 320px;
      height: 80px;
      margin-top: 40px;
    }
    .give-up {
      margin-top: 27px;
      font-size: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 33px;
      text-decoration: underline;
    }
  }
  img {
    &.top-image {
      position: absolute;
      top: -75px;
      left: 200px;
      width: 220px;
      height: 136px;
    }
  }
}
.text-primary {
  color: #FF4633;
}
.bold {
  font-weight: 600;
}
</style>